import { React, useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import IconButton from "@mui/material/IconButton";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Button from "@mui/material/Button";
import { ToastContainer } from "react-toastify";
import { Dropdown } from "semantic-ui-react";
import Tooltip from "@mui/material/Tooltip";
import Papa from "papaparse";
import MDBadge from "components/MDBadge";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import { Stack, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DescriptionIcon from "@mui/icons-material/Description";
import colors from "assets/theme/base/colors";

const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

function TestInterviewScores() {
  // Variable Declarations
  const [all_applications, setAllApplications] = useState([]);
  const [all_campaigns, setAllCampaigns] = useState([]);
  const [all_campuses, setAllCampuses] = useState([]);
  const [all_departments, setAllDepartments] = useState([]);
  const [campaign_ids, setCampaignIds] = useState([]);
  const [campus_ids, setCampusIds] = useState([]);
  const [department_ids, setDepartmentIds] = useState([]);

  const [applications, setApplications] = useState([]);
  const [campaign_id, setCampaignId] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("");

  const [editedRowIdTest, setEditedRowIdTest] = useState(null);
  const [newTestScore, setNewTestScore] = useState("");
  const [editedRowIdInterview, setEditedRowIdInterview] = useState(null);
  const [newInterviewScore, setNewInterviewScore] = useState("");

  const handleEditTestScoreClick = (rowId, currentTestScore) => {
    setEditedRowIdTest(rowId);
    setNewTestScore(currentTestScore);
  };

  const handleEditInterviewScoreClick = (rowId, currentInterviewScore) => {
    setEditedRowIdInterview(rowId);
    setNewInterviewScore(currentInterviewScore);
  };

  const handleSaveTestScoreClick = (id) => {
    postNewTestScore(id);
    setEditedRowIdTest(null);
  };

  const handleSaveInterviewScoreClick = (id) => {
    postNewInterviewScore(id);
    setEditedRowIdInterview(null);
  };

  //Dialog Settings
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [anchorEl, setAnchorEl] = useState(null);
  const [opens, setOpens] = useState(false);
  const [currentAppId, setCurrentAppId] = useState(null);

  const handleClick = (event, appId) => {
    setAnchorEl(event.currentTarget);
    setOpens(true);
    setCurrentAppId(appId);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpens(false);
    setCurrentAppId(null);
  };

  const handleViewApplication = (id) => {
    window.open(`/view-application/${currentAppId}`);
  };

  // Session Storage handling
  var user = JSON.parse(sessionStorage.getItem("user"));
  if (user) {
    var organization_id = user.organization_id;
  } else {
    var organization_id = null;
  }

  // Rows & Columns Injection
  const columns = [
    { Header: "Sr.No", accessor: "serial", align: "center" },
    { Header: "ID", accessor: "id", align: "left" },
    { Header: "Full Name", accessor: "full_name", align: "center" },
    { Header: "Father Name", accessor: "father_name", align: "center" },
    { Header: "Campaign", accessor: "campaign_name", align: "center" },
    { Header: "Degree", accessor: "degree_name", align: "center" },
    { Header: "Department", accessor: "department_name", align: "center" },
    { Header: "Campus", accessor: "campus_name", align: "center" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Test Score", accessor: "test_score", align: "center" },
    { Header: "Interview Score", accessor: "interview_score", align: "center" },
    { Header: "Actions", accessor: "actions", align: "center" },
  ];

  const rows =
    all_applications.length > 0
      ? all_applications.map((app, index) => ({
          serial: index + 1,
          id: app.id,
          full_name: app.first_name + " " + app.last_name,
          father_name: app.father_name,
          campaign_name: app.campaign_name,
          degree_name: app.first_preference_name,
          department_name: app.first_department_name,
          campus_name: app.campus_name,
          status:
            app.is_completed === 0 && app.is_verified === 0 ? (
              <MDBox ml={-1}>
                <MDBadge
                  badgeContent="Incomplete"
                  color="warning"
                  variant="gradient"
                  size="sm"
                />
              </MDBox>
            ) : app.is_completed === 1 && app.is_verified === 1 ? (
              <MDBox ml={-1}>
                <MDBadge
                  badgeContent="Accepted"
                  color="success"
                  variant="gradient"
                  size="sm"
                />
              </MDBox>
            ) : app.is_completed === 0 && app.is_verified === 2 ? (
              <MDBox ml={-1}>
                <MDBadge
                  badgeContent="Rejected"
                  color="error"
                  variant="gradient"
                  size="sm"
                />
              </MDBox>
            ) : app.is_completed === 1 && app.is_verified === 0 ? (
              <MDBox ml={-1}>
                <MDBadge
                  badgeContent="Completed"
                  color="info"
                  variant="gradient"
                  size="sm"
                />
              </MDBox>
            ) : app.is_completed === 1 && app.is_verified === 2 ? (
              <MDBox ml={-1}>
                <MDBadge
                  badgeContent="Resubmitted"
                  color="secondary"
                  variant="gradient"
                  size="sm"
                />
              </MDBox>
            ) : null,
          test_score: (
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                {editedRowIdTest === app.id ? (
                  <>
                    <TextField
                      label="Edit Test Score"
                      type="number"
                      value={newTestScore}
                      onChange={(e) => setNewTestScore(e.target.value)}
                    />
                    <Tooltip title="Save Test Score">
                      <IconButton
                        aria-label="Save Test Score"
                        color="primary"
                        onClick={() => handleSaveTestScoreClick(app.id)}
                      >
                        <SaveIcon style={{ color: "green" }} />
                      </IconButton>
                    </Tooltip>
                  </>
                ) : (
                  <>
                    <span>{app.obtained_test_score}</span>
                    <Tooltip title="Edit Test Score">
                      <IconButton
                        aria-label="Edit Test Score"
                        color="primary"
                        onClick={() =>
                          handleEditTestScoreClick(
                            app.id,
                            app.obtained_test_score
                          )
                        }
                      >
                        <EditIcon style={{ color: "blue" }} />
                      </IconButton>
                    </Tooltip>
                  </>
                )}
              </div>
            </div>
          ),
          interview_score: (
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                {editedRowIdInterview === app.id ? (
                  <>
                    <TextField
                      label="Edit Interview Score"
                      type="number"
                      value={newInterviewScore}
                      onChange={(e) => setNewInterviewScore(e.target.value)}
                    />
                    <Tooltip title="Save Interview Score">
                      <IconButton
                        aria-label="Save Interview Score"
                        color="primary"
                        onClick={() => handleSaveInterviewScoreClick(app.id)}
                      >
                        <SaveIcon style={{ color: "green" }} />
                      </IconButton>
                    </Tooltip>
                  </>
                ) : (
                  <>
                    <span>{app.obtained_interview_score}</span>
                    <Tooltip title="Edit Interview Score">
                      <IconButton
                        aria-label="Edit Interview Score"
                        color="primary"
                        onClick={() =>
                          handleEditInterviewScoreClick(
                            app.id,
                            app.obtained_interview_score
                          )
                        }
                      >
                        <EditIcon style={{ color: "blue" }} />
                      </IconButton>
                    </Tooltip>
                  </>
                )}
              </div>
            </div>
          ),
          actions: (
            <>
              <div>
                <IconButton
                  aria-label="more"
                  id={`long-button-${index}`}
                  aria-controls={opens ? "long-menu" : undefined}
                  aria-expanded={opens ? "true" : undefined}
                  aria-haspopup="true"
                  onClick={(event) => handleClick(event, app.id)}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id="long-menu"
                  anchorEl={anchorEl}
                  open={opens}
                  onClose={handleClose}
                >
                  <MenuItem onClick={handleViewApplication}>
                    <VisibilityIcon
                      style={{ marginRight: "15px", color: "blue" }}
                    />{" "}
                    View & Verify Application
                  </MenuItem>
                </Menu>
              </div>
            </>
          ),
        }))
      : [
          {
            serial: null,
            id: null,
            full_name: null,
            father_name: null,
            campaign_name: null,
            degree_name: null,
            department_name: null,
            campus_name: null,
            status: null,
            test_score: null,
            interview_score: null,
            actions: null,
          },
        ];

  const handleExportCSV = () => {
    const data = [
      columns.map((col) => col.Header),
      ...rows.map((row) => Object.values(row)),
    ];

    const csv = Papa.unparse(data);

    const blob = new Blob([csv], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "Test/Interview Scores.csv";

    link.click();
  };

  const handleSearchKeywordChange = (e) => {
    const searchTerm = e.target.value.trim().toLowerCase();
    setSearchKeyword(searchTerm);

    if (searchTerm === "") {
      getAllApplications();
    } else {
      let filteredApplications = all_applications.filter((app) => {
        const idMatch = app.id && app.id.toString().includes(searchTerm);
        const firstNameMatch =
          app.first_name && app.first_name.toLowerCase().includes(searchTerm);
        const lastNameMatch =
          app.last_name && app.last_name.toLowerCase().includes(searchTerm);
        const fatherNameMatch =
          app.father_name && app.father_name.toLowerCase().includes(searchTerm);
        const campaignNameMatch =
          app.campaign_name &&
          app.campaign_name.toLowerCase().includes(searchTerm);
        const degreeNameMatch =
          app.first_preference_name &&
          app.first_preference_name.toLowerCase().includes(searchTerm);
        const departmentNameMatch =
          app.first_department_name &&
          app.first_department_name.toLowerCase().includes(searchTerm);
        const campusNameMatch =
          app.campus_name && app.campus_name.toLowerCase().includes(searchTerm);
        const testScoreMatch =
          app.obtained_test_score &&
          app.obtained_test_score.toLowerCase().includes(searchTerm);
        const interviewScoreMatch =
          app.obtained_interview_score &&
          app.obtained_interview_score.toLowerCase().includes(searchTerm);

        return (
          idMatch ||
          firstNameMatch ||
          lastNameMatch ||
          fatherNameMatch ||
          campaignNameMatch ||
          degreeNameMatch ||
          departmentNameMatch ||
          campusNameMatch ||
          testScoreMatch ||
          interviewScoreMatch
        );
      });

      setAllApplications(filteredApplications);
    }
  };

  // GET Api calls
  const getAllCampaigns = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    };
    await fetch(BASE_URL + `/campaign/get_campaigns`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setAllCampaigns(data.campaigns);
      })
      .catch((error) => console.log(error));
  };

  const getAllCampuses = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    };
    await fetch(BASE_URL + `/campus/get_campuses`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setAllCampuses(data.campuses);
      })
      .catch((error) => console.log(error));
  };

  const getDepartmentsByCampuses = async (selectedCampuses) => {
    let data = { campus_ids: selectedCampuses };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(data),
    };
    await fetch(
      BASE_URL + `/department/get_departments_by_campuses`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setAllDepartments(data.departments);
      })
      .catch((error) => console.log(error));
  };

  const getAllApplications = async () => {
    let data = {
      campaign_ids: campaign_ids,
      department_ids: department_ids,
    };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(data),
    };
    await fetch(
      BASE_URL + `/application/get_filtered_applications`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setAllApplications(data.applications);
      })
      .catch((error) => console.log(error));
  };

  const postNewTestScore = async (id) => {
    let data = { application_id: id, obtained_test_marks: newTestScore };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(data),
    };
    await fetch(BASE_URL + `/application/edit_test_result`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        getAllApplications();
      })
      .catch((error) => console.log(error));
  };

  const postNewInterviewScore = async (id) => {
    let data = {
      application_id: id,
      obtained_interview_marks: newInterviewScore,
    };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(data),
    };
    await fetch(
      BASE_URL + `/application/edit_interview_result`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        getAllApplications();
      })
      .catch((error) => console.log(error));
  };

  const handleDepartments = (event, data) => {
    const { value } = data;
    const selectedDepartments = Array.isArray(value) ? value : [value];

    setDepartmentIds(selectedDepartments);
  };

  const handleCampaigns = (event, data) => {
    const { value } = data;
    const selectedCampaigns = Array.isArray(value) ? value : [value];

    setCampaignIds(selectedCampaigns);
  };

  const handleCampuses = (event, data) => {
    const { value } = data;
    const selectedCampuses = Array.isArray(value) ? value : [value];

    setCampusIds(selectedCampuses);
    getDepartmentsByCampuses(selectedCampuses);
  };

  const fetchData = () => {
    getAllApplications();
  };

  useEffect(() => {
    getAllCampaigns();
    getAllCampuses();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Stack
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
              paddingRight={3}
            >
              <div className="col-md-4">
                <label>Campaign</label>
                <Dropdown
                  id="filter_campaign_id"
                  name="filter_campaign_id"
                  placeholder="Select Campaign"
                  fluid
                  selection
                  multiple={true}
                  search
                  value={campaign_ids}
                  onChange={handleCampaigns}
                  options={all_campaigns.map((camp) => ({
                    key: camp.id,
                    text: camp.name,
                    value: camp.id,
                  }))}
                />
              </div>

              <div className="col-md-4">
                <label>Campus</label>
                <Dropdown
                  id="filter_campus_id"
                  name="filter_campus_id"
                  placeholder="Select Campus"
                  fluid
                  selection
                  multiple={true}
                  search
                  value={campus_ids}
                  onChange={handleCampuses}
                  options={all_campuses.map((camp) => ({
                    key: camp.id,
                    text: camp.name,
                    value: camp.id,
                  }))}
                />
              </div>

              <div className="col-md-4">
                <label>Department</label>
                <Dropdown
                  id="filter_department_id"
                  name="filter_department_id"
                  placeholder="Select Departments"
                  fluid
                  multiple={true}
                  search
                  selection
                  value={department_ids}
                  onChange={handleDepartments}
                  options={all_departments.map((dept) => ({
                    key: dept.id,
                    text: dept.department_name,
                    value: dept.department_id,
                  }))}
                />
              </div>
            </Stack>

            <Stack
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              className="mt-3"
            >
              <Button
                variant="contained"
                endIcon={
                  <SearchIcon
                    sx={{
                      width: "22px",
                      height: "22px",
                      marginLeft: "22px",
                    }}
                  />
                }
                onClick={fetchData}
                style={{
                  borderColor: "white",
                  color: "white",
                  fontWeight: 500,
                  height: "40px",
                  fontSize: "16px",
                }}
              >
                Get Applications
              </Button>
            </Stack>

            <Card
              className="mt-5"
              sx={{
                boxShadow: "none",
                border: "1px solid #DADADAEE",
                borderRadius: "5px",
              }}
            >
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                variant="gradient"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  spacing={1}
                  sx={{ width: "100%" }}
                >
                  <Stack sx={{ flexGrow: 1 }}>
                    <Paper
                      component="form"
                      sx={{
                        p: "2px 4px",
                        display: "flex",
                        alignItems: "center",
                        width: "333px",
                        border: "1px solid #8C8C8C",
                        boxShadow: "none",
                      }}
                    >
                      <InputBase
                        sx={{ ml: 1, flex: 1, fontSize: "16px" }}
                        placeholder="Search"
                        inputProps={{ "aria-label": "search voucher" }}
                        value={searchKeyword}
                        onChange={handleSearchKeywordChange}
                      />
                      <SearchIcon
                        sx={{ color: "gray", width: "22px", height: "22px" }}
                      />
                    </Paper>
                  </Stack>
                  <Button
                    variant="outlined"
                    endIcon={
                      <DescriptionIcon
                        sx={{
                          width: "22px",
                          height: "22px",
                          marginLeft: "22px",
                        }}
                      />
                    }
                    onClick={() => {
                      handleExportCSV();
                    }}
                    style={{
                      color: "white",
                      background: info.main,
                      fontWeight: 500,
                      height: "40px",
                      fontSize: "16px",
                    }}
                  >
                    Export CSV
                  </Button>
                </Stack>
              </MDBox>
              <MDBox pt={3}>
                {all_applications && all_applications.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <img
                      src="nodata.png"
                      style={{
                        display: "block",
                        margin: "auto",
                        width: "20%",
                        height: "20%",
                      }}
                    />
                  </div>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default TestInterviewScores;
